export default {
  // Main navigation sections
  products: 'Products',
  support: 'Support',
  resources: 'Resources',

  // Product links
  carInsurance: 'Car Insurance',
  healthInsurance: 'Health Insurance',
  medicalMalpractice: ' Medical Malpractice Insurance   ',
  travel: 'Travel Insurance',
  fleet: 'Fleet',
  protectionAndSaving: 'Protection and Saving',
  marine: 'Marine Insurance',
  civilLiability: 'Civil Liability Insurance',

  // Support links
  contactUs: 'Contact Us',
  privacyPolicy: 'Privacy Policy',
  termsAndConditions: 'Terms & Conditions',
  helpCenter: 'Help Center',

  // Resource links
  thirdPartyInsurance: 'Third Party Insurance',
  comprehensiveInsurance: 'Comprehensive Insurance',
  vehicleHistoryCheck: 'Vehicle History - Mojaz',
  smartPackage: 'Smart Package',
  tameeniHero: 'Tameeni Hero',
  tameeniOffers: 'Tameeni Offers',
  policyUploadStatus: 'Upload Status Inquiry (Moroor/Najm)',
  qitafEarnRedeem: 'Qitaf Earn & Redeem',
  faq: "FAQ's",
  blog: 'Our blog',

  // Health insurance sub-items
  health_individual: 'Individual Health Insurance',
  health_sme: 'SME Health',

  // Health insurance sub-sections
  forBusiness: 'For Business',
  forIndividual: 'For Individual',
  smeHealth: 'SME Health',

  // Health insurance descriptions
  smeDescription: 'Health Insurance For companies with members less than 250',
  corporateHealthInsurance: 'Corporate Health Insurance',
  corporateDescription: 'For companies with more than 250 member',
  individualDescription: 'Health Insurance For you & your family',
  premiumResidency: 'Premium Residency Health Insurance  ',
  premiumResidencyDescription: 'Health Insurance For you & your family',
  domesticHelper: 'Domestic Helper',
  domesticHelperDescription: 'Health & Contract Insurance',

  // Social media links
  facebook: 'Facebook',
  x: 'X',
  instagram: 'Instagram',
  youtube: 'YouTube',
  snapchat: 'Snapchat',
  whatsapp: 'WhatsApp',

  // Legacy translations (keeping for backward compatibility)
  insuranceAuthority: 'Insurance Authority Publications',
  partners: 'Partners',
  contactus: 'Contact Us',
  privacy: 'Privacy Policy',
  terms: 'Terms & Conditions',
  third_party_insurance: 'Third Party Insurance',
  comprehensive_insurance: 'Comprehensive Insurance',
  vehicle_history_check: 'Vehicle History Check (Mojaz)',
  smart_package: 'Smart Package',
  tameeni_offers: 'Tameeni Offers',
  medical_malpractice: 'Medical Malpractice    ',
  home: 'Home Insurance',
  careers: 'Careers',
  my_account: 'My Account',
  copyRightsText:
    'Copyright © Tameeni 2025. All rights reserved. Company Tameeni LOSATA AL-TAMIN AL-ALAKTAROUNI',
  downloadTameeniApp: 'Download Tameeni App',
  followTameeni: 'Follow Tameeni',
  poweredBy: 'Powered and operated by',
} as const
